import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AIContentTools = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const aiTools = [
    {
      path: '/audio-analysis',
      icon: '🎙️',
      title: '음성 분석',
      description: '강의/회의 녹음을 텍스트로 변환하고 핵심 내용을 요약합니다.',
      status: 'available'
    },
    {
      path: '/content-summarize',
      icon: '📝',
      title: '콘텐츠 요약',
      description: '긴 텍스트나 문서를 AI가 핵심 내용으로 요약합니다.',
      status: 'available'
    },
    {
      path: '/video-creator',
      icon: '🎬',
      title: '영상 제작',
      description: '숏폼 영상 제작, 이미지 업스케일, 이미지→비디오 변환',
      status: 'available'
    },
    {
      path: '/storyboard',
      icon: '📖',
      title: '스토리보드',
      description: 'AI가 스토리를 이미지 프롬프트로 변환하여 시각화합니다.',
      status: 'coming-soon'
    },
    {
      icon: '🔄',
      title: '콘텐츠 변환',
      description: '문체, 형식, 언어 등을 AI가 자동으로 변환합니다.',
      status: 'coming-soon'
    },
    {
      icon: '📰',
      title: '블로그 초안',
      description: '키워드만 입력하면 AI가 블로그 글을 작성합니다.',
      status: 'coming-soon'
    },
  ];

  return (
    <div className="max-w-[1200px] mx-auto p-8">
      <header className="text-center mb-12">
        <h1 className="text-[2.5rem] font-bold text-gray-900 mb-2">AI 도구</h1>
        <p className="text-lg text-gray-500">다양한 AI 도구로 업무 효율을 높이세요</p>
      </header>

      <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-6">
        {aiTools.map((tool, index) => (
          <div
            key={index}
            className={`bg-white border rounded-2xl p-8 text-center transition-all duration-300 relative cursor-${tool.path && tool.status === 'available' ? 'pointer' : 'default'} ${
              tool.status === 'available'
                ? 'border-green-500 bg-gradient-to-br from-white to-green-50 hover:border-green-700 hover:shadow-[0_4px_20px_rgba(76,175,80,0.2)] hover:-translate-y-0.5'
                : 'border-gray-200 hover:border-blue-500 hover:shadow-[0_4px_20px_rgba(59,130,246,0.1)] hover:-translate-y-0.5'
            }`}
            onClick={() => tool.path && tool.status === 'available' && navigate(tool.path)}
          >
            <div className="text-5xl mb-4">{tool.icon}</div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">{tool.title}</h3>
            <p className="text-sm text-gray-500 leading-relaxed mb-4">{tool.description}</p>
            <span className={`inline-block px-3 py-1.5 rounded-full text-xs font-semibold ${
              tool.status === 'available'
                ? 'bg-green-100 text-green-700'
                : 'bg-gray-100 text-gray-500'
            }`}>
              {tool.status === 'available' ? '사용 가능' : '준비 중'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AIContentTools;
